import { useState, useCallback, useContext, useEffect } from "react";
import { SocketContext } from "../contexts/SocketContext";
import { AlertContext } from "../contexts/AlertContext";
import { LoaderContext } from "../contexts/LoaderContext";

export const useComponents = () => {

    const [components, setComponents] = useState([]);

    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);

    useEffect(() => {
        let unsubscribed = true;

        unsubscribed && getComponents();

        return () => unsubscribed = false;
    }, []);

    const getComponents = useCallback(() => {
        setOpenLoader(true);
        socket.emit("frontend:obtener-componentes", (response) => {
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current?.handleOpen('error', message);
                return;
            }

            setComponents(data);
            setOpenLoader(false);
        });
    }, []);

    return {
        components
    }
}